









import Vue from 'vue';
import {Component} from "vue-property-decorator";
import SuggestedGame from "./SuggestedGame.vue";
import {ContentPack, CurrentGame} from "../../../types";
import EventApi from "../../api/EventsApi";
//@ts-ignore
import store from "../../store";

@Component({
    components: {SuggestedGame},
    props: {}
})

export default class GamePreset extends Vue {
    private activity: null|CurrentGame = null;
    private selectedPack: null|ContentPack = null;

    mounted(): void
    {
        EventApi.addEventListener(EventApi.SHOW_SUGGESTED_TASK, this.showSuggestedTask);
    }

    beforeDestroy(): void
    {
        EventApi.removeEventListener(EventApi.SHOW_SUGGESTED_TASK, this.showSuggestedTask);
    }

    /**
     * Все игры
     */
    private get activities(): Array<CurrentGame>
    {
        return store.getters.getActivitiesList;
    }

    /**
     * Показать предлагаемую игру
     */
    public showSuggestedTask(e: any): void
    {
        if (!e.detail) {
            return;
        }

        let activityId = Number(e.detail.activityId);
        let packId = Number(e.detail.contentPackId);

        let activity = this.activities.find((game: CurrentGame) => {
            return game.id === activityId;
        });

        if (!activity) {
            return;
        }

        let contentPack = Object.values(activity.contentPacks).find((pack: ContentPack) => {
            return pack.id === packId;
        });

        if (!contentPack) {
            return;
        }

        this.activity = activity;
        this.selectedPack = contentPack;
    }

    /**
     * Закрыть предлагаемую игру
     */
    public closeSuggestedGameModal(): void
    {
        this.activity = null;
        this.selectedPack = null;
    }
}
